import React from 'react';
import styled from 'styled-components';
import { BlueButton } from '../../StyledComponents';
import Select from 'react-select';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../HomePage/EsperSignUpFormComponent';
import Axios from 'axios';
import { navigate } from 'gatsby';
import { validatePhone } from '../../../globalFunctions';
import apiHost from '../../../apiHost';
import PhoneInputClass from '../ContactUs/PhoneInput';
const contactTypeOptions = [
  { value: 'Hardware', label: 'Hardware' },
  { value: 'Software', label: 'Software' },
  { value: 'Connectivity', label: 'Connectivity' },
  { value: 'Payments', label: 'Payments' },
  { value: 'Peripherals', label: 'Peripherals' },
  { value: 'Video & Data', label: 'Video & Data' },
  { value: 'Other', label: 'Other' },
];
const RequestDemoFormComponent = styled.div`
  font-size: 14px;
  text-align: center;
  /* position: absolute;
  right: 2rem;
  top: 3rem; */
  /* width: fit-content; */

  padding-right: 18rem;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-right: 14rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-right: 5rem;
  }
  @media (max-width: 1000px) {
    position: relative;
    top: unset;
    display: grid;
    justify-content: center;
    right: unset;
    padding: 0rem;
    width: 90%;
    max-width: 450px;
    margin: auto;
    margin-top: 2rem;
  }
`;
export const RequestDemoFormContainer = styled.div`
  border-radius: 4px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: fit-content;
  box-shadow: 0 2px 21px 0 rgba(41, 35, 58, 0.12);
  background-color: #ffffff;
  display: grid;
  /* justify-items: center; */
  padding-top: 2rem;
  padding-bottom: 3rem;
  @media (max-width: 520px) {
    /* width: 100%; */
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const RequestDemoTitle = styled.h1`
  font-size: 28px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
`;

const BlueButtonNew = styled(BlueButton)`
  margin-top: 0rem;
  min-width: 18rem;
  margin: 0 !important;
  margin-top: 10px;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

export default class RequestDemoForm extends React.Component<any, any> {
  state = {
    // companyError: false,
    contactError: false,
    nameError: false,
    emailError: false,
    deviceNumberError: false,
    preferredDateError: false,
    defaultCountry: {
      icon: '🇺🇲',
      name: 'United States',
      abbr: 'US',
      code: '1',
      suggested: true,
    },
    email: '',
    name: '',
    jobTitle: '',
    website: '',
    contact: '',
    solution: '',
    date: new Date(),
    typeOptions: [],
    deviceNumber: '',
    submitError: false,
    loaded: false,
  };

  isAllValid = () =>
    !(
      // this.state.companyError ||
      (
        this.state.contactError ||
        this.state.nameError ||
        this.state.preferredDateError ||
        this.state.deviceNumberError ||
        this.state.emailError
      )
    );

  validateAll = () => {
    // this.validateCompany();
    this.validateDeviceCount();
    this.validateContact();
    this.validateFullName();
    this.validateEmail();
  };

  componentDidMount() {
    this.setState({
      loaded: true,
    });
  }
  navigateThankyou = () => {
    localStorage.setItem('prevPage', 'partner-page');
    navigate('/submitted');
  };

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  sendData = (token: any) => {
    this.validateAll();
    if (this.isAllValid()) {
      localStorage.setItem('customerName', `${this.state.name}`);
      localStorage.setItem('demoTime', `${this.state.date.toISOString()}`);
      const hubspotToken = this.getCookieValue('hubspotutk');
      Axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/7bd3279d-acd4-42e7-86e3-7e381c403671',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'firstname',
              value: this.state.name,
            },
            {
              name: 'phone',
              value: `${
                this.state.defaultCountry
                  ? `+${this.state.defaultCountry.code} `
                  : ''
              }${this.state.contact.trim()}`,
            },
            {
              name: 'company',
              value: this.state.jobTitle,
            },
            {
              name: 'device_type',
              value: this.state.website,
            },
            {
              name: 'what_type_of_solution_do_you_provide_',
              value: this.state.solution,
            },
            {
              name: 'choose_one_or_more_',
              value: this.state.typeOptions?.toString(),
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then((response: any) => {
          this.setState({
            // companyError: false,
            contactError: false,
            nameError: false,
            emailError: false,
            deviceNumberError: false,
            preferredDateError: false,
            email: '',
            name: '',
            jobTitle: '',
            website: '',
            contact: '',
            solution: '',
            date: '',
            typeOptions: [],
            deviceNumber: '',
          });
          this.navigateThankyou();
        })
        .catch((error: any) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.number_of_device')) {
                this.setState({ deviceNumberError: true });
              } else if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.phone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  // VALIDATIONS

  validateFullName = () => {
    if (this.state.name.length === 0 || this.state.name.length > 30) {
      this.setState({
        nameError: true,
      });
    } else {
      this.setState({
        nameError: false,
      });
    }
  };

  validateEmail = (isNotOnFocus?: any) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isNotOnFocus) {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      } else {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      }
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event });
  };

  validateCompany = () => {
    if (this.state.company.length === 0 || this.state.company.length > 30) {
      this.setState({
        companyError: true,
      });
    } else {
      this.setState({
        companyError: false,
      });
    }
  };
  validateDeviceCount = () => {
    if (this.state.deviceNumber <= 0) {
      this.setState({
        deviceNumberError: true,
      });
    } else {
      this.setState({
        deviceNumberError: false,
      });
    }
    // }
  };

  validateContact = () => {
    if (!validatePhone(this.state.contact)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage: 'Please enter a valid contact number',
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  //   Input Recievers

  handleNameChange = (event: any) =>
    this.setState({ name: event.target.value });
  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });
  handleJobTitle = (event: any) =>
    this.setState({ jobTitle: event.target.value });
  handleWebsite = (event: any) =>
    this.setState({ website: event.target.value });
  handleSolution = (event: any) => {
    this.setState({ solution: event.target.value });
    console.log(this.state.solution);
  };
  handleDeviceChange = (event: any) =>
    this.setState({ deviceNumber: event.target.value });
  handleContactChange = (event: any) =>
    this.setState({ contact: event.target.value });
  handleSelect = (value: any) => {
    console.group('Value Changed');
    console.log(value?.map((item: any) => item?.value));
    // console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    this.setState({ typeOptions: value?.map((item: any) => item?.value) });
  };
  onKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/\+|-/.test(keyValue)) {
      event.preventDefault();
    }
  };

  handleFocusContact = () => this.setState({ contactFocus: true });
  render() {
    return (
      <RequestDemoFormComponent>
        <RequestDemoFormContainer id={this.props.formId}>
          <RequestDemoTitle>Connect with Esper</RequestDemoTitle>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.name}
              aria-label="Full Name"
              // backgroundImage={this.state.loaded && FirstNameIcon}
              maxLength={149}
              onChange={this.handleNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={'Full Name'}
              name="Full Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid name
                </>
              ) : (
                this.state.nameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.name.length > 1
                      ? 'Please enter a valid name'
                      : 'Please enter your name'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.email}
              aria-label="Email"
              // backgroundImage={this.state.loaded && EmailIcon}
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.submitError}
              type="email"
              placeholder={'Work Email'}
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid email address
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? 'Please enter a valid email address'
                      : 'Please enter an email address'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>

          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="company"
              value={this.state.jobTitle}
              aria-label="Job Title"
              // backgroundImage={this.state.loaded && CompanyIcon}
              maxLength={149}
              onChange={this.handleJobTitle}
              // onBlur={this.validateCompany}
              // error={this.state.companyError || this.state.submitError}
              type="text"
              placeholder={'Job Title'}
              name="Job Title"
            />

            {/* <PasswordMatchError id="company-error">
              {this.state.companyError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid company name
                </>
              ) : (
                this.state.companyError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? 'Please enter a valid company name'
                      : 'Please enter your company name'}
                  </>
                )
              )}
            </PasswordMatchError> */}
          </div>
          <div style={{ display: 'grid', paddingTop: '2rem' }}>
            <StyledInputs
              id={`${this.props.formId}__company`}
              value={this.state.website}
              aria-label="Website"
              // backgroundImage={this.state.loaded && CompanyIcon}
              maxLength={149}
              onChange={this.handleWebsite}
              // onBlur={this.validateCompany}
              // error={this.state.companyError || this.state.submitError}
              type="text"
              placeholder={'Website'}
              name="Website"
            />
            {/* <PasswordMatchError id="company-error">
              {this.state.deviceNumberError === false &&
              this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter number of devices
                </>
              ) : (
                this.state.deviceNumberError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    Please enter number of devices
                  </>
                )
              )}
            </PasswordMatchError> */}
          </div>
          <div style={{ display: 'grid', paddingTop: '2rem' }}>
            <PhoneInputClass
              handleFocusContact={this.handleFocusContact}
              handleContactChange={this.handleContactChange}
              validateContactNumber={this.validateContact}
              handleCountrySelect={this.handleCountrySelect}
              defaultCountry={this.state.defaultCountry}
              contactNumber={this.state.contact}
              contactError={this.state.contactError}
              submitError={this.state.submitError}
              messages={this.props.messages}
            />
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id={`${this.props.formId}__solution`}
              value={this.state.solution}
              aria-label="What Type of Solution Do You Provide?"
              // backgroundImage={this.state.loaded && FirstNameIcon}
              maxLength={149}
              onChange={this.handleSolution}
              // onBlur={this.validateFullName}
              // error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={'What Type of Solution Do You Provide?'}
              name="What Type of Solution Do You Provide"
            />
          </div>
          <div
            style={{
              display: 'grid',
              padding: '2.25rem 0em 1.5em',
              fontFamily: 'inherit',
              fontSize: 'initial',
              fontWeight: 'inherit',
              color: '#4d4d4d !important',
            }}
          >
            <Select
              // defaultValue={[contactTypeOptions[2], contactTypeOptions[3]]}
              id={`${this.props.formId}__contacttypeoptions`}
              placeholder={'Choose One or More'}
              isMulti={true}
              name="colors"
              options={contactTypeOptions}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(value) => this.handleSelect(value)}
              // backgroundImage={this.state.loaded && FirstNameIcon}
            />
          </div>

          <div style={{ display: 'grid', marginTop: '8px' }}>
            <BlueButtonNew
              id={`${this.props.formId}__submit`}
              onClick={this.sendData}
            >
              Submit
            </BlueButtonNew>
          </div>
        </RequestDemoFormContainer>
      </RequestDemoFormComponent>
    );
  }
}
